// extracted by mini-css-extract-plugin
export var circle = "_b5-1";
export var exitConfirmationModal = "_b5-5";
export var iframe = "_b5-0";
export var offline = "_b5-3";
export var online = "_b5-2";
export var workstationSelectError = "_b5-4";